<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { updated } from '$app/state';
  import { Button } from '$lib/components/ui/button/index.js';
  import Download from '@lucide/svelte/icons/download';
  import { wmsApp, installWmsApp } from '$lib/wms/app/wms-app-state.svelte';
</script>

{#if wmsApp.installPrompt && !wmsApp.inAppWindow}
  <Button size="sm" variant="outline" disabled={wmsApp.installing} onclick={installWmsApp}
    aria-label={$_('vms.app.install')} title={$_('vms.app.install')}>
    <Download class="size-4" aria-hidden="true" />
    <span class="sr-only sm:not-sr-only">{$_('vms.app.install')}</span>
  </Button>
{/if}
{#if wmsApp.installFailed}
  <span role="status" class="text-xs text-destructive">{$_('vms.app.installFailed')}</span>
{/if}
{#if updated.current}
  <span role="status" class="text-xs text-muted-foreground" title={$_('vms.app.updateDescription')}>
    {$_('vms.app.updateReady')}
  </span>
{/if}
